import { PhoneCall } from 'lucide-react';

import { EmptyResult } from '@/components/empty-result';
import { ProtectedComponent } from '@/components/ProtectedComponent';

import { emit } from '@/hooks/use-event-handler';

import { Permissions } from '@/constants';

export const EmptyPhoneNumber = () => (
  <ProtectedComponent
    requiredPermissions={[Permissions.PhoneNumberCreateUpdate]}
    fallback={
      <EmptyResult
        icon={<PhoneCall className="h-12 w-12 text-muted-foreground/40" />}
        title="No Phone Numbers Found"
      />
    }
  >
    <EmptyResult
      icon={<PhoneCall className="h-12 w-12 text-muted-foreground/40" />}
      title="No Phone Numbers Found"
      description="Create your first phone number by clicking 'Create a phone number'."
      onCreate={() => emit('phone-number:create')}
      createButtonText="Create a phone number"
    />
  </ProtectedComponent>
);
